import { bookingApiSlice } from '../api/booking/bookingApiSlice';
import Logger from '../common/logger';
import { store } from '../store/store';
import { CustomerMailRefusal, mailBlockedOf } from '../utils/customerMailGuard';
import { CreateRoomRentalBookingPayload } from '../types/bookingCreation';

export const useCreateRoomRentalBooking = () => {
    return async (
        roomRentalData: CreateRoomRentalBookingPayload, 
        saveMode: 'save_only' | 'save_and_send_email',
    ): Promise<{success: boolean, error?: string, reason?: string, mailBlocked?: CustomerMailRefusal | null}> => {
        try {
            const response = await store.dispatch(
                bookingApiSlice.endpoints.createRoomRentalBooking.initiate(
                    { 
                        data: roomRentalData, 
                        saveMode: saveMode,
                    },
                ),
            ).unwrap();
            // PO, 2026-10-30: saved, but the customer mail may have been refused.
            return {success: true, mailBlocked: mailBlockedOf(response)};
        } catch (error) {
            Logger('createRoomRentalBooking').error(error);
            const reason = (error as { data?: { reason?: unknown } })?.data?.reason;
            return {
                success: false,
                reason: typeof reason === 'string' ? reason : undefined,
                error: 'An error occurred while creating the booking. Please try again.',
            };
        }
    };
};
